export enum AppArea {
  LOCATIONS,
  CUSTOMERS,
  SALES,
  TERRITORIES,
  COMPETITORS,
  COTENANTS,
}
